export default "/static/build/skill-7.png";